import { Phone, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";

const WHATSAPP_URL = "https://wa.me/5562986293474?text=Olá! Visitei o site da RL Refrigeração e gostaria de solicitar um orçamento.";

export default function Hero() {
  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="relative min-h-[100vh] flex items-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1757219525975-03b5984bc6e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
          alt="Ar condicionado instalação"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="hero-overlay absolute inset-0" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="max-w-3xl">
          {/* Badge */}
          <div
            className="inline-block bg-white/15 backdrop-blur-sm border border-white/20 px-4 py-1.5 mb-6 animate-fade-in"
          >
            <span className="text-white text-xs font-bold tracking-[0.2em] uppercase font-['Barlow_Condensed']">
              Desde 2016 em Goiânia
            </span>
          </div>

          {/* Headline */}
          <h1
            data-testid="hero-headline"
            className="text-5xl md:text-7xl lg:text-8xl font-extrabold text-white leading-[0.95] tracking-tight font-['Barlow_Condensed'] animate-fade-in-up"
          >
            Soluções em
            <br />
            <span className="text-white">Refrigeração</span>
            <br />
            <span className="text-[#CC1B1B]">Profissional</span>
          </h1>

          {/* Subtitle */}
          <p
            data-testid="hero-subtitle"
            className="mt-6 text-lg md:text-xl text-white/90 max-w-xl leading-relaxed animate-fade-in-up stagger-2 font-['Manrope']"
          >
            Instalação, manutenção e projetos de refrigeração para residências, comércios e indústrias. Trabalhamos com todas as marcas.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mt-10 animate-fade-in-up stagger-3">
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
              <Button
                data-testid="hero-cta-whatsapp"
                className="bg-[#CC1B1B] hover:bg-[#991B1B] text-white text-base px-8 py-6 font-['Barlow_Condensed'] uppercase tracking-wider font-bold rounded-sm shadow-lg hover:shadow-xl transition-all"
              >
                <Phone className="w-5 h-5 mr-2" />
                Solicitar Orçamento
              </Button>
            </a>
            <a href="#servicos">
              <Button
                data-testid="hero-cta-services"
                variant="outline"
                className="border-2 border-white text-white hover:bg-white hover:text-[#0E86D4] text-base px-8 py-6 font-['Barlow_Condensed'] uppercase tracking-wider font-bold rounded-sm bg-transparent"
              >
                Nossos Serviços
              </Button>
            </a>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-6 mt-14 max-w-lg animate-fade-in-up stagger-4">
            {[
              { value: "9+", label: "Anos de experiência" },
              { value: "500+", label: "Projetos realizados" },
              { value: "4.9", label: "Avaliação Google" },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-3xl md:text-4xl font-extrabold text-white font-['Barlow_Condensed']">
                  {stat.value}
                </div>
                <div className="text-white/70 text-xs mt-1 font-['Manrope'] font-medium">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-float">
        <a href="#servicos" aria-label="Rolar para serviços">
          <ChevronDown className="w-8 h-8 text-white/60" />
        </a>
      </div>
    </section>
  );
}
